import { useContext } from 'react';
import UserInfo from 'src/components/UserInfo';
import { CurrentUserContext } from 'src/context/CurrentUserContext';

const UserInfoQuery = ({ style = {} }: { style?: React.CSSProperties }): JSX.Element => {
  const { studentInfo } = useContext(CurrentUserContext);
  return <UserInfo {...studentInfo} {...studentInfo?.studentInfo} style={style} />;
};
export default UserInfoQuery;
